<template>
    <el-container class="">     
        <app-aside v-show="showAside"></app-aside>
        <app-main></app-main>
    </el-container>
</template>
<script>
import AppAside from '../app-aside1'

import AppMain from '../app-main'


export default {
  name: 'layout',
  components: {
    AppAside,

    AppMain,
  },
    data () {
        return {
            showAside:true,
        }
    },
    created(){
       
    },
    mounted(){
        this.$bus.$off("toaside");
        this.$bus.$on("toaside", () => {
            this.showAside = !this.showAside;
        });
    }
}
</script>
<style>
  .section{
    display: flex;
    display: -webkit-flex;
    background: #F8F8F8;
  }
</style>



// WEBPACK FOOTER //
// src/pages/views/layout/first-router/haveAside.vue